import { Button, Loader } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useEffect, useRef, useState } from "react";
import { GoogleMap as DefaultGoogleMap, Marker, Polyline, withGoogleMap, withScriptjs } from "react-google-maps";
import { compose, withProps } from "recompose";
import { createMarkerIcon, generateMarkerText } from "../utility/util";
import useCurrentLocation from "./use_current_location";

let GoogleMap: any = DefaultGoogleMap;

const MapRender = compose(
  withProps((props) => ({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDV8uT7yErfIloYQBp_PXlEyJnTBWJ3Hpk&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <Loader />,
    containerElement: <div style={{ height: props.height || `400px`, position: 'relative' }} />,
    mapElement: <div style={{ height: `100%` }} />,
  })),
  withScriptjs,
  withGoogleMap,
)((props) => {
  const { center: parentCenter, onIconClick = null, autoGenerate : autoGenerateParent = false, origin, destination, waypoints, onCalculate, onPoint } = props;

  const [autoGenerate, setAutoGenerate] = useState(null)
  const [directions, setDirections] = useState(null)
  const [loadingRoutes, setLoadingRoutes] = useState(false)
  const [center, setCenter] = useState({ lat: -15.7975154, lng: -47.8918874 });
  const [loadingCurrentLocation, setLoadingCurrentLocation] = useState(false);
  const key = `${origin?.place_id ? origin?.place_id : `${origin?.lat}::${origin?.lng}`};${(waypoints || []).map(w => w.location?.place_id ? w.location?.place_id : `${w.location?.lat}::${w.location?.lng}`)};${destination?.place_id ? destination?.place_id : `${destination?.lat}::${destination?.lng}`}`

  const directionsRendererRef = useRef();

  const { getCurrentLocation } = useCurrentLocation();
  
  useEffect(() => {
    setAutoGenerate(autoGenerateParent)
  }, [autoGenerateParent])
  
  useEffect(() => {
    if(parentCenter) setCenter(parentCenter);
  }, [parentCenter])

  useEffect(() => {
    onCalculate && onCalculate(directions)
  }, [directions])
  
  useEffect(() => {
    if(waypoints.length > 25) setAutoGenerate(false);
  }, [waypoints])
  
  useEffect(() => {
    setLoadingCurrentLocation(true)
    getCurrentLocation()
    .then(res => {
      setLoadingCurrentLocation(false)
      setCenter(res);
    })
    .catch((err) => {
      showNotification({message: err.message, color: "yellow"})
      setLoadingCurrentLocation(false)
    })
  }, [])
  
  return (
    <>
      {loadingCurrentLocation && <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}><Loader /></div>}
      <GoogleMap
        defaultCenter={origin || center}
        defaultZoom={13}
        onClick={e => {
          if(autoGenerate && waypoints.length > 24){
            setAutoGenerate(false);
            setDirections(null);
          }
          onPoint && onPoint({ lat: e.latLng.lat(), lng: e.latLng.lng() })
        }}
      >
        <Polyline
          path={[
            origin,
            ...(waypoints || []).map(w => w.location),
            destination,
          ]}
          options={{
            strokeColor: "#FF0000",
            strokeOpacity: 0.4,
            strokeWeight: 4
          }}
        />
        {[
          origin,
          ...(waypoints || []).map(w => w.location),
          destination,
        ].filter(nn => nn).map((m, i) => <Marker
          draggable
          // icon={createMarkerIcon(generateMarkerText(i))}
          icon={createMarkerIcon(null, { color: m.color })}
          onDragEnd={(e) => onPoint && onPoint({ index: i, lat: e.latLng.lat(), lng: e.latLng.lng() })}
          position={m} 
          onRightClick={(e) => onIconClick && onIconClick({ index: i, lat: m.lat, lng: m.lng, right: true })}
          onClick={() => onIconClick && onIconClick({ index: i, lat: m.lat, lng: m.lng })}
        />)}
      </GoogleMap>
      {!autoGenerate && waypoints.length <= 25 && <Button style={{ position: 'absolute', bottom: 30, left: 10 }} variant="filled" size="xs" onClick={() => setAutoGenerate(true)}>Gerar rota</Button>}
    </>
  );
});

export default MapRender;